import { render, staticRenderFns } from "./data-access-filter.vue?vue&type=template&id=ef9d148c&scoped=true&"
import script from "./data-access-filter.ts?vue&type=script&lang=ts&"
export * from "./data-access-filter.ts?vue&type=script&lang=ts&"
import style0 from "./data-access-filter.scss?vue&type=style&index=0&id=ef9d148c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9d148c",
  null
  
)

export default component.exports